import { useMutation } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

interface PublishAgentData {
  uuid: string;
}

interface PublishAgentResponse {
  data: any;
}

export function usePublishAgent() {
  const { keycloak } = useKeycloak();

  return useMutation({
    mutationFn: async ({
      uuid,
    }: PublishAgentData): Promise<PublishAgentResponse> => {
      const response = await fetch(
        `${
          import.meta.env.VITE_IMPORT_ENGINE_ENDPOINT
        }/api/v1/bundles/generate_bundle/functions/publish_agent`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'POST',
          body: JSON.stringify({ uuid }),
        }
      );

      const data = await response.json();

      return {
        data: data?.data,
      };
    },
  });
}
